import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20orange%20and%20cream%20flowing%20shapes%2C%20minimalist%20digital%20atmosphere%2C%20smooth%20curves%20and%20subtle%20light%20effects%2C%20professional%20yet%20inviting%20aesthetic%2C%20clean%20modern%20illustration&width=1800&height=600&seq=cta-bg-jiujiu-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-accent-600/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
            准备好开始您的数字之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-white/80 leading-relaxed mb-8">
            立即加入久久在线，百万用户的选择，开启流畅、安全、便捷的在线服务体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="px-8 py-3 rounded-full bg-white text-primary-700 font-medium text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              免费注册
              <i className="ri-arrow-right-line ml-2 text-xs"></i>
            </a>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              联系销售
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}